<script setup>
import {computed, defineEmits, defineProps, onMounted, ref} from "vue";
import store from "@/store";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import RealName from "@/components/login/RealName.vue";
import {ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";
import {siteConfig} from "@/utils/config";
import {useRoute} from "vue-router";

const prop = defineProps(['show', 'product'])
const emit = defineEmits(['closed', 'success'])
const showProduct = ref(false)
const changeProduct = ref({})
const account = computed(() => store.state.account)
const loading = ref(false)
const rechargeMobile = ref("")
const sendSms = ref(false)
const realDialog = ref(false)
const order_from = computed(()=>store.state.orderFrom)
const copType = computed(()=>{
  let coup = store.state.coupon
  return siteConfig[coup]
})
onMounted(() => {
  store.commit("getCoupon")
  store.dispatch("getAccounts")
  showProduct.value = prop.show
  changeProduct.value = prop.product
  store.commit("getOrderFrom")
})
const logo = require("@/assets/images/shuangke/logo.png")

const pay = () => {
  //判断是否输入手机号
  if (!/^1[2-9]\d{9}$/.test(rechargeMobile.value)) {
    return ElMessage.error({message: `请输入接收短信手机号`})
  }
  if (!sendSms.value && copType.value.login !== 'xm_air') {
    sendSms.value = true;
    return;
  }
  loading.value = true
  sendSms.value = false;
  let body = {
    type: copType.value.login || "scal",
    uid: account.value.uid,
    cust_id: account.value.cust_id,
    cid: changeProduct.value.id,
    number: 1,
    token: /^quanjifen_.+/.test(account.value.token) ? null : account.value.token,
    mobile: rechargeMobile.value,
    order_from: order_from.value
  }

  if(body.type === 'xm_air'){
    //
    body.access_token = account.value.access_token
    body.user_id = account.value.user_id
  }
  new axiosApi({
    encode: "pay",
    method: "coupon/scorePay",
    body
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7401") {
      return ElMessage.error({message: res.message.content})
    } else if (res.message.code === '7401') {
      realDialog.value = true;
      return
    }
    showProduct.value = false
    if(copType.value.login === 'xm_air'){
      window.location.href = res.data.url
    } else {
      emit("success")
      store.commit("setOrder", res.data)
    }

  }, () => loading.value = false)
}
</script>

<template>
  <el-drawer direction="btt" v-model="showProduct" :with-header="false" class="product-drawer" size="500"
             @closed="emit('closed')">
    <div class="recharge-drawer">
      <div class="product-items">
        <div class="logo">
          <el-image :src="logo"/>
        </div>
        <div class="product-name">
          <h3>{{ changeProduct.name }}</h3>
          <div>
            <el-text type="info">{{ changeProduct.title }}</el-text>
          </div>
          <div class="miles-ites">
            <p class="miles">{{ changeProduct.score }}</p>
            <p class="unit">{{ copType.login === 'xm_air'?'积分':'里程' }}</p>
          </div>
        </div>
      </div>
      <div class="tips">
        <el-text type="info">
          兑换成功后，预留手机将收到含“兑换码链接”短信，<el-text type="danger">请确保预留手机号码填写正确</el-text>，因手机号码填写错误造成的损失由会员本人承担。
        </el-text>
      </div>
      <el-card shadow="never">
        <div class="recharge-items">
          <div class="recharge-items-its">预留手机号</div>
          <div class="recharge-items-its recharge-items-value">
            <el-input :placeholder="`请输入接收短信手机号`" clearable v-model="rechargeMobile"/>
          </div>
        </div>
      </el-card>
      <el-card shadow="never">
        <div class="recharge-items">
          <div class="recharge-items-its">可用{{ copType.login === 'xm_air'?'积分':'里程' }}</div>
          <div class="recharge-items-its">{{ account.balance_miles }}</div>
        </div>
        <div class="recharge-items">
          <div class="recharge-items-its">支付{{ copType.login === 'xm_air'?'积分':'里程' }}</div>
          <div class="recharge-items-its">{{ changeProduct.score }}</div>
        </div>
      </el-card>
      <div class="recharge-btn">
        <el-button round :type="copType.login === 'xm_air'?'primary':'danger'" size="large" @click="pay" :loading="loading"
                   :disabled="Object.keys(account).length && parseInt(changeProduct.score) > parseInt(account.balance_miles)">{{
            parseInt(changeProduct.score) > parseInt(account.balance_miles) ? `可用${copType.login === 'xm_air'?'积分':'里程'}不足` : '立即兑换'
          }}
        </el-button>
      </div>
    </div>
  </el-drawer>
  <send-sms-components :show="sendSms" :login-account="account" v-if="sendSms" @sends="pay"/>
  <real-name :dialog="realDialog" @changeModel="realDialog=false" v-if="realDialog"/>
</template>

<style scoped lang="less">
.product-drawer {
  border-radius: 20px 20px 0 0;
}

.recharge-drawer {
  .product-items {
    display: flex;
    //align-items: baseline;
    align-items: center;

    .logo {
      flex-basis: 65px;
      width: 65px;
      height: 45px;
      margin-right: 10px;
      background: #D02C2A;
      border-radius: 15px;
      padding: 10px;

      .el-image {
        width: 65px;
        height: 40px;
      }
    }

    .product-name {
      //line-height: 1.75;
      line-height: 1.2;

      .miles-ites {
        display: flex;
        align-items: flex-end;
        height: 25px;
        line-height: 25px;
        margin-top: 15px;
        //align-items: center;

        .miles {
          color: #E31D1A;
          font-size: 1.5rem;
          margin-right: 5px;
        }

        .unit {
          font-size: .85rem;
          margin-bottom: -3px;
        }
      }
    }
  }

  .el-card {
    margin: 15px auto;
    border-radius: 12px;

    .recharge-items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 15px auto;

      & + .recharge-items {
        padding-top: 10px;
        border-top: var(--el-border);
      }

      .recharge-items-its {

        &.recharge-items-value {
          width: 65%;

        }

        .el-input__wrapper {
          background-color: #e5e5e5;
          height: 30px;
          box-shadow: none;
        }
      }
    }
  }

  .recharge-btn {
    width: 97%;
    margin: auto;

    .el-button {
      width: 100%;
    }
  }
}

.tips{
  margin: 15px auto;
  text-align: justify;
}
</style>
